import safariImg from "../assets/banner3.jpg";
import safariImg2 from "../assets/beans.jpg";
import safariImg3 from "../assets/banner1.jpg";
import safariImg4 from "../assets/serengeti.jpg";
import trekImg from "../assets/kilimanjaro.jpg";
import trekImg2 from "../assets/acc.jpg";
import trekImg3 from "../assets/beans.jpg";
import trekImg4 from "../assets/camp.jpg";
import zanzibarImg from "../assets/zanzibar1.jpg";
import zanzibarImg2 from "../assets/sunflower.jpg";
import zanzibarImg3 from "../assets/banner1.jpg";
import zanzibarImg4 from "../assets/banner5.jpg";

export const dropdownContent = {
  safaris: [
    {
      title: "Luxury Safari",
      duration: "9 Days, 8 Nights",
      text: "Arusha to Serengeti, Ngorongoro Crater in premium lodges with Big Five.",
      img: safariImg,
      nav: { item: "services", subItem: "luxury" },
    },
    {
      title: "Tanzania Safari",
      duration: "7 Days, 6 Nights",
      text: "Tarangire, Manyara, Serengeti, Crater - complete northern circuit.",
      img: safariImg2,
      nav: { item: "services", subItem: "migration" },
    },
    {
      title: "Serengeti Wilderness",
      duration: "3 Days, 2 Nights",
      text: "Full game drives tracking Great Migration in endless plains.",
      img: safariImg4,
      nav: { item: "services", subItem: "serengeti" },
    },
    {
      title: "Photographic Safari",
      duration: "9 Days, 8 Nights",
      text: "Ngorongoro Crater to Serengeti for prime wildlife photography.",
      img: safariImg3,
      nav: { item: "services", subItem: "photographic" },
    },
  ],
  trekking: [
    {
      title: "Rongai Route",
      duration: "7 Days, 6 Nights",
      text: "Quieter northern approach with broad mountain views to Kilimanjaro summit.",
      img: trekImg4,
      nav: { item: "services", subItem: "rongai" },
    },
    {
      title: "Machame Route",
      duration: "7 Days, 6 Nights",
      text: "Scenic route with strong acclimatization through rainforests to summit.",
      img: trekImg2,
      nav: { item: "services", subItem: "machame" },
    },
    {
      title: "Lemosho Route",
      duration: "8 Days, 7 Nights",
      text: "High-scenic trail with varied terrain and excellent camp rhythm.",
      img: trekImg3,
      nav: { item: "services", subItem: "lemosho" },
    },
    {
      title: "Marangu Route",
      duration: "9 Days, 6 Nights",
      text: "The only route up to where you sleep in the huts than tents.",
      img: trekImg,
      nav: { item: "services", subItem: "marangu" },
    },
  ],
  zanzibar: [
    {
      title: "Zanzibar Experience",
      duration: "7 Days, 6 Nights",
      text: "Stone Town, Prison Island, Spice Farm, Safari Blue & Nungwi beaches.",
      img: zanzibarImg,
      nav: { item: "services", subItem: "stone-town" },
    },
    {
      title: "Nungwi Beach",
      duration: "5 Days, 4 Nights",
      text: "Stone Town heritage + northern white sand beaches relaxation.",
      img: zanzibarImg4,
      nav: { item: "services", subItem: "nungwi" },
    },
    {
      title: "Zanzibar Adventure",
      duration: "8 Days, 7 Nights",
      text: "Stone Town culture + Pongwe Beach ultimate getaway.",
      img: zanzibarImg2,
      nav: { item: "services", subItem: "islands" },
    },
    {
      title: "Tanzania + Zanzibar",
      duration: "15 Days, 14 Nights",
      text: "Safari parks then Zanzibar paradise beaches and Stone Town.",
      img: zanzibarImg3,
      nav: { item: "services", subItem: "tanzania_zanzibar" },
    },
  ]
};
